import React, { useState } from 'react';
import {
  Row,
  Form,
  DatePicker,
  Switch,
  Tag,
  Input,
  Button,
  Popover,
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
  PlusSquareFilled,
} from '@ant-design/icons';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib/form';
import { shouldUpdateCompare } from 'utils/utils2';
import ThirdPartyInput from 'components/ThirdPartyInput';
import Text from 'antd/lib/typography/Text';
import TextArea from 'antd/lib/input/TextArea';
import MGListSelect from '../Components/MGListSelect';
import InputRate from 'components/InputRate';
import TaxSelect from 'components/TaxSelect';
import InputCurrency from 'components/InputCurrency';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue';
import MarketingInput from '../MarketingCompaign/MarketingInput';
import PricingListSelect from 'components/PricingListSelect';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import AssetUpload from 'components/AssetUpload';
import AssetCatalogAmount from './components/AssetCatalogAmount';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Col from 'antd/lib/grid/col';
import AssetCatalogDetailsModal from './AssetCatalogDetailsModal';
import ModalController from 'components/ModalController';

export type TabAssetGeneralDataProps = {
  form: FormInstance;
  catalogid: number;
  setIsmulti: (test: any) => void;
  setState: any;
  state: any;
  refetch: any;
};

const TabAssetGeneralData = ({
  form,
  catalogid,
  setIsmulti,
  setState,
  state,
  refetch,
}: TabAssetGeneralDataProps) => {
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const recalculate = (netamountorigin: any) => {
    let taxrate = form.getFieldValue('taxrate') ?? 0;
    let netamount = 0;
    let disc = 0;
    let discountamount = 0;
    let taxamountorigin = 0;
    let grossorigin = 0;

    disc =
      (form.getFieldValue('assetdiscountperc') / 100) *
      form.getFieldValue('assetnetamountorigine');
    netamount = form.getFieldValue('assetnetamountorigine') - disc;
    discountamount =
      form.getFieldValue('assetnetamountorigine') *
      (form.getFieldValue('assetdiscountperc') / 100);
    taxamountorigin =
      form.getFieldValue('assetnetamountorigine') * (taxrate / 100);
    grossorigin = form.getFieldValue('assetnetamountorigine') + taxamountorigin;

    const taxamount = netamount * (taxrate / 100);
    const grossamount = netamount + taxamount;

    form.setFieldsValue({
      assetnetamount: netamount,
      assettaxamount: taxamount,
      assetgrossamount: grossamount ?? 0,
      assetdiscountamount: discountamount,
      assetgrossamountorigine: grossorigin,
    });
  };
  return (
    <Form
      labelCol={{ span: 24 }}
      requiredMark
      wrapperCol={{ span: 24 }}
      form={form}
    >
      <Row gutter={32}>
        <UtinaCard
          level={5}
          xs={24}
          lg={13}
          comcode="assetGeneralInformation"
          additionalAttribute
        >
          <FormInput col xs={24} lg={12} xl={3} name="catalogid">
            <Value />
          </FormInput>
          <FormInput
            col
            xs={24}
            xl={13}
            name="assetlabel"
            rules={[{ required: true }]}
          />

          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare([
              'assetstatuslabel',
              'catalogstatus',
            ])}
            rules={[{ required: true }]}
          >
            {({ getFieldValue }) => (
              <FormInput col xs={24} lg={12} xl={3} name="catalogstatus">
                <Text>
                  {!getFieldValue('catalogstatus')
                    ? form.setFieldsValue({
                        catalogstatus: 'INIT',
                      })
                    : ''}
                  <Tag
                    color={
                      getFieldValue('catalogstatus') === 'ACTIVE'
                        ? 'success'
                        : getFieldValue('catalogstatus') === 'DISABLED'
                        ? 'error'
                        : 'blue'
                    }
                  >
                    {getFieldValue('assetstatuslabel')}
                  </Tag>
                </Text>
              </FormInput>
            )}
          </Form.Item>

          <FormInput
            col
            xs={24}
            md={8}
            name="assetsegment"
            comcode="assetsegment"
            rules={[{ required: true }]}
          >
            <ParListSelectWithLabelInValue
              parcode="ASSETPRD"
              //parvalueparent={props.flagreal ? 'RE' : 'EQ'}
              onChange={(e) => {
                setState({
                  ...state,
                  assetsegment: e,
                  assetfamily: '',
                  assettype: '',
                  assetcategory: '',
                  assetmodel: '',
                });
                form.setFieldsValue({
                  assetfamily: '',
                  assettype: '',
                  assetcategory: '',
                  assetmodel: '',
                  assetlabel: '',
                });
              }}
            />
          </FormInput>
          <Form.Item shouldUpdate={shouldUpdateCompare('assetsegment')} noStyle>
            {({ getFieldValue }) => {
              return (
                <FormInput
                  col
                  xs={24}
                  md={8}
                  name="assetfamily"
                  comcode="assetfamily"
                  rules={[{ required: true }]}
                >
                  <ParListSelectWithLabelInValue
                    parcode="ASSETFAM"
                    disabled={!getFieldValue('assetsegment')}
                    parvalueparent={getFieldValue('assetsegment')?.value}
                    onSelect={(e) => {
                      setState({
                        ...state,
                        assetfamily: e,
                        assettype: '',
                        assetcategory: '',
                      });
                      form.setFieldsValue({
                        assettype: '',
                        assetcategory: '',
                        assetmodel: '',
                        assetlabel: '',
                      });
                    }}
                  />
                </FormInput>
              );
            }}
          </Form.Item>
          <Form.Item shouldUpdate={shouldUpdateCompare('assetfamily')} noStyle>
            {({ getFieldValue }) => {
              return (
                <FormInput
                  col
                  xs={24}
                  md={8}
                  name="assettype"
                  comcode="assettype"
                  rules={[{ required: true }]}
                >
                  <ParListSelectWithLabelInValue
                    parcode="ASSETTYPE"
                    disabled={!getFieldValue('assetfamily')}
                    parvalueparent={getFieldValue('assetfamily')?.value}
                    onSelect={(e) => {
                      setState({
                        ...state,
                        assettype: e,
                        assetcategory: '',
                        assetmodel: '',
                      });
                      form.setFieldsValue({
                        assetcategory: '',
                        assetmodel: '',
                        assetlabel: e?.label,
                      });
                    }}
                  />
                </FormInput>
              );
            }}
          </Form.Item>

          <Form.Item shouldUpdate={shouldUpdateCompare('assettype')} noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                xs={24}
                md={8}
                name="assetcategory"
                comcode="assetcategory"
                rules={[{ required: true }]}
              >
                <ParListSelectWithLabelInValue
                  parcode="ASSETCAT"
                  disabled={!getFieldValue('assettype')}
                  parvalueparent={
                    getFieldValue(['assettype', 'value']) ??
                    getFieldValue('assettype')
                  }
                  allowClear
                  onSelect={(e) => {
                    form.setFieldsValue({
                      assetmodel: '',
                      assetlabel: getFieldValue('assetlabel') + ' ' + e?.label,
                    });
                    setState({
                      ...state,
                      assetcategory: e,
                      assetmodel: '',
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>

          <Form.Item
            shouldUpdate={shouldUpdateCompare('assetcategory')}
            noStyle
          >
            {({ getFieldValue }) => (
              <FormInput
                col
                xs={24}
                md={8}
                name="assetmodel"
                comcode="assetmodel"
              >
                <ParListSelectWithLabelInValue
                  parcode="ASSETMODEL"
                  disabled={!getFieldValue('assetcategory')}
                  parvalueparent={
                    getFieldValue(['assetcategory', 'value']) ??
                    getFieldValue('assetcategory')
                  }
                  allowClear
                  onSelect={(e) => {
                    form.setFieldsValue({
                      assetlabel: getFieldValue('assetlabel') + ' ' + e?.label,
                    });
                    setState({
                      ...state,
                      assetmodel: e,
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput col md={12} name="assetvariant" comcode="assetvariant">
                <Input />
              </FormInput>
            )}
          </Form.Item>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput col md={12} name="assetversion" comcode="assetversion">
                <Input />
              </FormInput>
            )}
          </Form.Item>

          <FormInput
            col
            xs={24}
            lg={12}
            xl={8}
            name="mgid"
            rules={[{ required: true }]}
          >
            <MGListSelect disabled />
          </FormInput>
          <FormInput col xs={24} lg={8} name="manufacturer">
            <ThirdPartyInput role="OEM" />
          </FormInput>
          <FormInput col xs={24} lg={8} name="supplier">
            <ThirdPartyInput role="SUPPLIER" />
          </FormInput>

          <FormInput col xs={24} lg={8} name="broker">
            <ThirdPartyInput role="BROKER" />
          </FormInput>

          <FormInput col xs={24} lg={8} name="networkcode">
            <ParListSelect parcode="NETWORK" />
          </FormInput>
          <FormInput
            col
            xs={24}
            lg={4}
            name="assetmulticomponents"
            valuePropName="checked"
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              onChange={(e) => {
                setIsmulti(e);
                form.setFieldsValue({
                  assetnetamount: 0,
                  assettaxamount: 0,
                  assetgrossamount: 0,
                  assetdiscountamount: 0,
                  assetgrossamountorigine: 0,
                  assetnetamountorigine: 0,
                  assetdiscountperc: 0,
                  taxcode: '',
                });
              }}
            />
          </FormInput>
          <FormInput col xs={24} lg={4} name="flagused" valuePropName="checked">
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            />
          </FormInput>

          <FormInput col xs={24} lg={6} name="catalogidlinkedlabel">
            <ModalController>
              {({ setVisible, visible }) => (
                <>
                  <a onClick={() => setVisible(true)}>
                    {form.getFieldValue('catalogidlinkedlabel')}
                  </a>
                  <AssetCatalogDetailsModal
                    title={form.getFieldValue('catalogidlinkedlabel')}
                    catalogid={form.getFieldValue('catalogidlinked')}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                  />
                </>
              )}
            </ModalController>
          </FormInput>

          <FormInput col xs={24} lg={6} name="catalogidoriginelabel">
            <ModalController>
              {({ setVisible, visible }) => (
                <>
                  <a onClick={() => setVisible(true)}>
                    {form.getFieldValue('catalogidoriginelabel')}
                  </a>
                  <AssetCatalogDetailsModal
                    title={form.getFieldValue('catalogidoriginelabel')}
                    catalogid={form.getFieldValue('catalogidorigine')}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                  />
                </>
              )}
            </ModalController>
          </FormInput>

          <FormInput
            col
            xs={24}
            lg={24}
            xl={24}
            name="assetdescription"
            style={{ height: '200 !important' }}
          >
            <TextArea rows={4} />
          </FormInput>
        </UtinaCard>

        <UtinaCard
          level={5}
          xs={24}
          lg={5}
          comcode="assetPicture"
          additionalAttribute
        >
          <FormInput col xs={24} name="startdate">
            <DatePicker />
          </FormInput>

          <FormInput col xs={24} name="enddate">
            <DatePicker />
          </FormInput>
          <FormInput col xs={24} name="deliverydelay">
            <ParListSelect parcode="DELDELAY" />
          </FormInput>

          <FormInput col xs={24} onlylabel="assetpictureurl">
            <AssetUpload
              catalogid={Number(catalogid ?? 0)}
              picid={1}
              name="assetpictureurl"
              form={form}
              objectreference=""
            />
          </FormInput>
        </UtinaCard>
        <UtinaCard level={5} xs={24} lg={5} comcode="Amounts">
          <Row gutter={5}>
            <FormInput col xs={24} md={12} name="currcode">
              <ParListSelect parcode="CURRENCY" />
            </FormInput>

            <Form.Item noStyle shouldUpdate={shouldUpdateCompare(['currcode'])}>
              {({ getFieldValue }) => (
                <FormInput
                  name="assetnetamountorigine"
                  col
                  xs={12}
                  lg={12}
                  xl={12}
                >
                  <Input.Group compact style={{ display: 'flex' }}>
                    <InputCurrency
                      onChange={(e) => recalculate(e)}
                      currcode={getFieldValue('currcode')}
                      disabled={getFieldValue('assetmulticomponents')}
                      fieldname="assetnetamountorigine"
                      noStyle
                    />
                    <div style={{ padding: '0px 2px' }}>
                      <Popover
                        content={
                          <AssetCatalogAmount
                            entityid={Number(catalogid) ?? 0}
                            entitytype="CATALOG"
                            currcode={getFieldValue('currcode')}
                          />
                        }
                        title={
                          <Row justify="space-between">
                            <Col>
                              <GetLabel
                                style={{ fontSize: 17 }}
                                label="AmountLIst"
                              />
                            </Col>
                            <Col>
                              <Button
                                onClick={() => {
                                  setOpen(false);
                                  refetch();
                                }}
                                icon={<CloseOutlined />}
                              />
                            </Col>
                          </Row>
                        }
                        trigger="click"
                        style={{
                          padding: '6px 8px',
                          color: '#37474f',
                        }}
                        visible={open}
                        overlayInnerStyle={{ width: 800 }}
                        onVisibleChange={() => {
                          !isNaN(catalogid) && setOpen(!open);
                          open && refetch();
                        }}
                        placement="left"
                      >
                        <Button
                          type="primary"
                          onClick={() => {
                            !isNaN(catalogid) && setOpen(true);
                          }}
                          disabled={isNaN(catalogid)}
                          icon={<PlusSquareFilled />}
                        />
                      </Popover>
                    </div>
                  </Input.Group>
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={5}>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare(['assetmulticomponents'])}
            >
              {({ getFieldValue, setFieldsValue }) => (
                <FormInput
                  col
                  xs={24}
                  lg={12}
                  xl={12}
                  name="taxcode"
                  rules={
                    !getFieldValue('assetmulticomponents') === true
                      ? [{ required: true }]
                      : [{}]
                  }
                >
                  <TaxSelect
                    taxflow="INOUT"
                    onSelected={(tax) => {
                      setFieldsValue({ taxrate: tax.taxrate });
                      recalculate(-1);
                    }}
                    disabled={getFieldValue('assetmulticomponents')}
                  />
                </FormInput>
              )}
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetmulticomponents',
              ])}
            >
              {({ getFieldValue }) => (
                <FormInput col xs={24} lg={12} xl={12} name="assetdiscountperc">
                  <InputRate
                    precision={2}
                    onChange={(e) => recalculate(-1)}
                    disabled={getFieldValue('assetmulticomponents')}
                  />
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={5}>
            <Form.Item noStyle shouldUpdate={shouldUpdateCompare(['currcode'])}>
              {({ getFieldValue }) => (
                <FormInput
                  name="assetgrossamountorigine"
                  col
                  xs={12}
                  lg={12}
                  xl={12}
                >
                  <InputCurrency
                    onChange={(e) => recalculate(e)}
                    currcode={getFieldValue('currcode')}
                    disabled={getFieldValue('assetmulticomponents')}
                  />
                </FormInput>
              )}
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetmulticomponents',
              ])}
            >
              {({ getFieldValue }) => (
                <FormInput
                  col
                  xs={24}
                  lg={12}
                  xl={12}
                  name="assetdiscountamount"
                >
                  <InputCurrency
                    currcode={getFieldValue('currcode')}
                    disabled={getFieldValue('assetmulticomponents')}
                    onChange={(e) => {
                      recalculate(e);
                    }}
                  />
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={5}>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetmulticomponents',
              ])}
            >
              {({ getFieldValue }) => (
                <FormInput col xs={24} lg={12} xl={12} name="assetnetamount">
                  <InputCurrency
                    onChange={(val) => recalculate(val)}
                    currcode={getFieldValue('currcode')}
                    disabled={getFieldValue('assetmulticomponents')}
                  />
                </FormInput>
              )}
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetmulticomponents',
              ])}
            >
              {({ getFieldValue }) => (
                <FormInput col xs={24} lg={12} xl={12} name="assettaxamount">
                  <InputCurrency
                    onChange={(val) => recalculate(val)}
                    currcode={getFieldValue('currcode')}
                    disabled={getFieldValue('assetmulticomponents')}
                  />
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetmulticomponents',
              ])}
            >
              {({ getFieldValue, setFieldsValue }) => (
                <Col xs={24} lg={12} xl={12}>
                  <InputCurrency
                    onChange={(val) => recalculate(val)}
                    currcode={getFieldValue('currcode')}
                    disabled={getFieldValue('assetmulticomponents')}
                    required
                    fieldname="assetgrossamount"
                  />
                </Col>
              )}
            </Form.Item>
          </Row>
        </UtinaCard>
      </Row>

      <Row gutter={32}>
        <UtinaCard level={5} xs={24} lg={16} comcode="FeesFormula">
          <Row gutter={32}>
            <FormInput col xs={24} lg={8} name="degfeesformula">
              <PricingListSelect
                style={{ width: '100%' }}
                params={{
                  offerid: 0,
                  ctecategory: '',
                  ctetype: 'DEGFEES',
                  filters: '',
                  finamount: 0,
                }}
              />
            </FormInput>
            <FormInput col xs={24} lg={8} name="spfeesformula">
              <PricingListSelect
                style={{ width: '100%' }}
                params={{
                  offerid: 0,
                  ctecategory: '',
                  ctetype: 'SPFEES',
                  filters: '',
                  finamount: 0,
                }}
              />
            </FormInput>
            <FormInput col xs={24} lg={8} name="tpofformula">
              <PricingListSelect
                style={{ width: '100%' }}
                params={{
                  offerid: 0,
                  ctecategory: '',
                  ctetype: 'PPOF',
                  filters: '',
                  finamount: 0,
                }}
              />
            </FormInput>
          </Row>
        </UtinaCard>
        <UtinaCard level={5} xs={24} lg={7} comcode="WebShop">
          <Row gutter={32}>
            <FormInput col xs={24} lg={15} name="markeCompain">
              <MarketingInput
                mcstatus="ACTIVE"
                onClear={() => {
                  form.setFieldsValue({
                    mcid: undefined,
                    markeCompain: undefined,
                  });
                }}
              />
            </FormInput>
            <FormInput
              col
              xs={24}
              lg={9}
              name="flagwebshop"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked
              />
            </FormInput>
          </Row>
        </UtinaCard>
      </Row>
    </Form>
  );
};

export default TabAssetGeneralData;
